<app-base-modal
  [title]="productCardsWeeklyRatingsResourceType.name"
>
  <div>
    <app-pc-rating-filters
      (handleFilterSelect)="handleFilterSelect($event)"
      (handleFilterDate)="handleFilterDate($event)"
    />
    <div class="content">
      <app-pc-rating-header
        class="rating-table-header"
        [weeklyCount]="weeklyCount()"
        [ratingData]="ratingData()"
      />
      <app-pc-rating-body
        class="rating-table-body"
        [ratingData]="ratingData()"
        [productCardId]="productCardId()"
        [weeklyCount]="weeklyCount()"
      />
    </div>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
